import { ColumnDef } from '@tanstack/react-table'
import { EditButton } from 'components/CantileverButton'
import styled from 'styled-components'

const EditButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 0.25rem;
  opacity: 0;
  width: 100%;
  height: 100%;

  &:hover {
    opacity: 1;
  }
`

export const createEditColumn = <TData extends object>(
  onEditRow: (row: TData) => void
) => {
  const column: ColumnDef<TData> = {
    id: 'edit-column',
    header: '',
    accessorKey: 'edit-column',
    maxSize: 32,
    cell: ({ row }) => (
      <EditButtonContainer>
        <EditButton
          ghost
          onClick={(e) => {
            e.stopPropagation()
            onEditRow(row.original)
          }}
          title='Edit'
        />
      </EditButtonContainer>
    ),
  }
  return column
}
